/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
	Faculty,
	FacultyFromJSON,
	FacultyFromJSONTyped,
	FacultyToJSON,
} from "./Faculty";
import {
	FeatureFlags,
	FeatureFlagsFromJSON,
	FeatureFlagsFromJSONTyped,
	FeatureFlagsToJSON,
} from "./FeatureFlags";

/**
 *
 * @export
 * @interface FacultyFeatureFlag
 */
export interface FacultyFeatureFlag {
	/**
	 *
	 * @type {string}
	 * @memberof FacultyFeatureFlag
	 */
	id?: string;
	/**
	 *
	 * @type {Date}
	 * @memberof FacultyFeatureFlag
	 */
	createdAt?: Date;
	/**
	 *
	 * @type {Date}
	 * @memberof FacultyFeatureFlag
	 */
	updatedAt?: Date;
	/**
	 *
	 * @type {string}
	 * @memberof FacultyFeatureFlag
	 */
	featureFlagsId?: string;
	/**
	 *
	 * @type {FeatureFlags}
	 * @memberof FacultyFeatureFlag
	 */
	featureFlags?: FeatureFlags;
	/**
	 *
	 * @type {string}
	 * @memberof FacultyFeatureFlag
	 */
	facultyId?: string;
	/**
	 *
	 * @type {Faculty}
	 * @memberof FacultyFeatureFlag
	 */
	faculty?: Faculty;
	/**
	 *
	 * @type {boolean}
	 * @memberof FacultyFeatureFlag
	 */
	value?: boolean;
}

export function FacultyFeatureFlagFromJSON(json: any): FacultyFeatureFlag {
	return FacultyFeatureFlagFromJSONTyped(json, false);
}

export function FacultyFeatureFlagFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): FacultyFeatureFlag {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		id: !exists(json, "id") ? undefined : json["id"],
		createdAt: !exists(json, "createdAt")
			? undefined
			: new Date(json["createdAt"]),
		updatedAt: !exists(json, "updatedAt")
			? undefined
			: new Date(json["updatedAt"]),
		featureFlagsId: !exists(json, "featureFlagsId")
			? undefined
			: json["featureFlagsId"],
		featureFlags: !exists(json, "featureFlags")
			? undefined
			: FeatureFlagsFromJSON(json["featureFlags"]),
		facultyId: !exists(json, "facultyId") ? undefined : json["facultyId"],
		faculty: !exists(json, "faculty")
			? undefined
			: FacultyFromJSON(json["faculty"]),
		value: !exists(json, "value") ? undefined : json["value"],
	};
}

export function FacultyFeatureFlagToJSON(
	value?: FacultyFeatureFlag | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		id: value.id,
		createdAt:
			value.createdAt === undefined ? undefined : value.createdAt.toISOString(),
		updatedAt:
			value.updatedAt === undefined ? undefined : value.updatedAt.toISOString(),
		featureFlagsId: value.featureFlagsId,
		featureFlags: FeatureFlagsToJSON(value.featureFlags),
		facultyId: value.facultyId,
		faculty: FacultyToJSON(value.faculty),
		value: value.value,
	};
}
